/**
 * Instant Data Scraper — table/list scraper
 *
 * Exposes three images — `pokeball64.png`, `serp_default.png`, `serp_hover.png` —
 * matched to every origin with no `use_dynamic_url`. The names are distinctive to this
 * extension and, as images, load through `probeImage` without a CORS grant.
 *
 * Manifest verified against version 1.6.1.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ofaokhiedipichpaobibbnahnkdoiiah';

export const instantDataScraper: ExtensionDefinition = {
  id: ID,
  name: 'Instant Data Scraper',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  notes:
    'Exposes three distinctively-named images to every origin with no dynamic URL. ' +
    'Detection is CORS-free and conclusive.',
  signals: [
    {
      id: 'war-pokeball-image',
      kind: 'web-accessible-resource',
      description:
        'Load pokeball64.png via <img> — the extension\'s toolbar icon, exposed to ' +
        'every origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'pokeball64.png'),
    },
    {
      id: 'war-serp-default',
      kind: 'web-accessible-resource',
      description:
        'Load serp_default.png via <img>. A second distinctively-named image, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'serp_default.png'),
    },
  ],
};
